/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactElement, useRef, useState } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { Button } from '../../Button';

import styles from './SlideMenu.module.scss';
import { MenuItem } from '../../utils/interfaces/Menu';
import { Icon } from '../../Icon';
import { NotificationCounter } from '../../NotificationNumber/NotificationCounter';
import { ColorPalettes } from '../../Landing/LandingBlock/LandingBlock';

interface SlideMenuProps {
  isOpen: boolean;
  onClose: () => void;
  items: MenuItem[];
  colorPalette?: ColorPalettes;
  shortLogo?: ReactElement;
}

export const SlideMenu = ({
  isOpen = false,
  onClose = () => {},
  items,
  colorPalette = 'unknown',
  shortLogo = null,
}: SlideMenuProps) => {
  const ref = useRef<HTMLDivElement>(undefined);
  const location = useLocation();
  const [activateAnimation, setActivateAnimation] = useState(false);
  return (
    <div
      color-palette={colorPalette}
      ref={ref}
      onClick={(event) => {
        if (ref.current === event.target) {
          setActivateAnimation(true);
          const timeout = setTimeout(() => {
            setActivateAnimation(false);
            onClose();
            clearTimeout(timeout);
          }, 200);
        }
      }}
      className={cn(
        styles.background,
        isOpen && styles.opened,
        activateAnimation && styles['animate-close']
      )}
    >
      <div className={styles['vertical-menu']}>
        <div className={styles['close-header']}>
          {shortLogo && <Button className={styles.logo}>{shortLogo}</Button>}
          <Button
            className={styles.button}
            iconPlace="only-icon"
            icon="cancel"
            onClick={() => {
              setActivateAnimation(true);
              const timeout = setTimeout(() => {
                setActivateAnimation(false);
                onClose();
                clearTimeout(timeout);
              }, 200);
            }}
          />
        </div>
        <ul className={styles['items-slide']}>
          {items.map((item) => {
            return (
              <Button
                className={cn(
                  styles['item-slide'],
                  item.endpoint === location.pathname && styles.active
                )}
                onClick={() => {
                  onClose();
                  item.onClick();
                }}
                key={item.name}
              >
                <li>
                  {item?.notificationNumber > 0 && (
                    <NotificationCounter
                      classname={styles.counter}
                      number={item?.notificationNumber}
                    />
                  )}
                  <Icon alt={item.name} type={item.icon} />
                  <p>{item.name}</p>
                </li>
              </Button>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
